import { render } from "./Names.vue?vue&type=template&id=4752344a&scoped=true"
import script from "./Names.vue?vue&type=script&lang=js"
export * from "./Names.vue?vue&type=script&lang=js"

import "./Names.vue?vue&type=style&index=0&id=4752344a&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4752344a"]])

export default __exports__